<p-button (onClick)="showDialog = true">Poveži</p-button>

<ng-container *ngIf="showDialog">
  <p-dialog
    [resizable]="false"
    [(visible)]="showDialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{width: '100vw', height: '50vh'}"
    appendTo="body"
  >
    <h2>Odaberite predmet za povezivanje: </h2>
    <div *ngIf="this.itemPredmetId">
      <app-odaberi-predmet [currentViewName]="'seup_predmet_u_radu'" [itemPredmetId]="this.itemPredmetId" (itemSelected)="onSelectedItem($event)"></app-odaberi-predmet>
    </div>
  </p-dialog>
</ng-container>
